import { render, staticRenderFns } from "./CategoryCreate.vue?vue&type=template&id=54fc7039&scoped=true&"
import script from "./CategoryCreate.vue?vue&type=script&lang=js&"
export * from "./CategoryCreate.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCreate.vue?vue&type=style&index=0&id=54fc7039&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fc7039",
  null
  
)

export default component.exports